// extracted by mini-css-extract-plugin
export default {"productGrid":"p1-z","centerLink":"q1-z","productSection":"r1-z","item":"s1-z","ctaButton":"t1-z"};